exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._27Uw8fo9rGrvnr{margin-left:8px}.vE8uKcBl9PMnJD{font-weight:600;color:#5e6c84}.M7H7bE4oMCKmIy{color:#5e6c84}", ""]);

// exports
exports.locals = {
	"viewCopyComponent": "_27Uw8fo9rGrvnr",
	"viewCopyText": "vE8uKcBl9PMnJD",
	"iconViewCopy": "M7H7bE4oMCKmIy"
};